<div class="fixed-top">
  <header class="top-bar mode-movile">
    <!--    <div class="container">-->
    <div class="row">
      <!-- social icon-->
      <div class="col-sm-12">
        <ul class="social-network mt-b">
<!--          <li class="nav-item nav-link">
            <a class="waves-effect waves-dark" *ngIf="showBalanceInfo && isAllowedViewActualBalance">
                   <span class="color-golden"> <i class="fa fa-hand-holding-usd" aria-hidden="true"></i>
                    &nbsp;{{ "NAV-BAR.CURRENT-BALANCE" | translate }}
                     :&nbsp;{{actualBalance}}&nbsp;<small>{{coin}}</small></span>
            </a>
          </li>-->
          <li class="dropdown menu cursor-pointer">
            <span class="waves-effect waves-dark" id="navbardrop23" data-toggle="dropdown">
              <i class="fa-globe fas color-golden"> </i> &nbsp;
              <i class="flag-icon {{getImageLang()}}"></i>
            </span>
            <div class="dropdown-menu dropdown-menu-right">
                      <span>
                      <button class="dropdown-item" (click)="changeSiteLanguage('en')"><span
                        class="flag-icon flag-icon-us"> </span>&nbsp;&nbsp;{{ "BUTTON.ENGLISH" | translate }}
                      </button>
                      <button class="dropdown-item" (click)="changeSiteLanguage('es')"><span
                        class="flag-icon flag-icon-pe"> </span>&nbsp;&nbsp;{{ "BUTTON.SPANISH" | translate }}
                      </button>
                      </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </header>
  <nav class="navbar navbar-expand-lg navbar-dark mx-background-top-linear">
    <a target="_blank" class="logo-cursor" (click)="login()">
      <img [src]="logoBase64ByCustomLink" class="border-radius remove-bg margin-top" width="100" alt=""
           height="35" *ngIf="setupLogo">
    </a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive"
            aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarResponsive">

      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link " [href]="urlAbout" target="_blank" *ngIf="!isAuthenticated">
            <span> <i class="fa fa-info-circle"></i> {{ "NAV-BAR.ABOUT-US" | translate }}</span>
          </a>
        </li>

        <li class="nav-item dropdown dmenu cursor-pointer"
            *ngIf="isAuthenticated && hasAuthority('own:application:view:menu:administration') || shippingNotification">
          <a class="nav-link" data-toggle="dropdown">
            <span> <i class="fa fa-cogs"></i> {{"NAV-BAR.ADMINISTRATION" | translate}}</span>
            <div class="dropdown-menu sm-menu">
              <a class="dropdown-item" [routerLink]="'enterprise'"
                 *ngIf="hasAuthority('own:enterprise:get:page')"><i class="fa fa-building"
                                                                    aria-hidden="true"></i> {{ "NAV-BAR.ENTERPRISE" | translate }}
              </a>
              <a class="dropdown-item cursor-pointer" [routerLink]="'job'"
                 *ngIf="hasAuthority('own:job:get:enterprise')"><i
                class="fa fa-briefcase"></i> {{ "NAV-BAR.JOB" | translate }}</a>
              <a class="dropdown-item" (click)="something()"
                 *ngIf="hasAuthority('own:person:get:page')"><i
                class="fa fa-user color-black"></i> {{ "NAV-BAR.PERSON" | translate }}
              </a>
              <a class="dropdown-item cursor-pointer" [routerLink]="'workflow'"
                 *ngIf="hasAuthority('own:workflow:get:enterprise')">
                <i class="fa fa-code-branch"></i> {{ "NAV-BAR.WORKFLOW" | translate }}
              </a>
              <a class="dropdown-item cursor-pointer" [routerLink]="'siecrendential'"
                 *ngIf="hasAuthority('own:sie:get:credential:enterprise')">
                <i class="fas fa-user-lock"></i>  {{ "NAV-BAR.SIE-CREDENTIAL" | translate }}
              </a>
              <a class="dropdown-item cursor-pointer" [routerLink]="'role'"
                 *ngIf="hasRole(ROLE_SUPERADMIN)">
                <i class="fa fa-suitcase" aria-hidden="true"></i>
                {{ "NAV-BAR.ROLES" | translate }}</a>
              <a class="dropdown-item cursor-pointer" [routerLink]="'authority'"
                 *ngIf="hasRole(ROLE_SUPERADMIN)">
                <i class="fas fa-shield-alt"></i> {{ "NAV-BAR.PERMISSIONS" | translate }}</a>
              <a class="dropdown-item cursor-pointer" [routerLink]="'installer'"
                 *ngIf="hasRole(ROLE_SUPERADMIN)"><i class="fa fa-window-restore"
                                                     aria-hidden="true"></i> {{ "NAV-BAR.INSTALLERS" | translate }}</a>
              <a class="dropdown-item cursor-pointer" [routerLink]="'tsacredential'"
                 *ngIf="hasRole(ROLE_SUPERADMIN)"><i class="fa fa-clock"
                                                     aria-hidden="true"></i> {{ "NAV-BAR.TSA-CREDENTIALS" | translate }}
              </a>
              <a class="dropdown-item cursor-pointer" [routerLink]="'view-balance'"
                 *ngIf="showBalanceInfo && (hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER))"><i
                class="fa fa-hand-holding-usd" aria-hidden="true"></i> {{ "NAV-BAR.BALANCES-RECEIVABLE" | translate }}
              </a>
              <a class="dropdown-item" (click)="openModalViewHistoricalBalance()"
                 *ngIf="showBalanceInfo && hasRole(ROLE_ADMIN) && hasConfigBalance"><i class="fa fa-history"
                                                                                       aria-hidden="true"></i> {{ "NAV-BAR.BALANCE-HISTORY" | translate }}
              </a>
              <a class="dropdown-item cursor-pointer" [routerLink]="'globalconfig'"
                 *ngIf="hasRole(ROLE_SUPERADMIN)"><i class="fa fa-wrench"
                                                     aria-hidden="true"></i> {{ "NAV-BAR.GLOBAL-SETTINGS" | translate }}
              </a>
              <a class="dropdown-item cursor-pointer" [routerLink]="'sign-batch-loading'"
                 *ngIf="hasAuthority('own:view:notcer:10200') || shippingNotification">
                <i class="fas fa-envelope-open-text"></i> {{ "NAV-BAR.DOCUMENTS-UPLOADED" | translate }}
              </a>
              <a class="dropdown-item cursor-pointer" [routerLink]="'deleteddocuments'"
                 *ngIf="hasRole(ROLE_SUPERADMIN)">
                <i class="fas fa-trash"></i> {{ "NAV-BAR.DELETE-DOCUMENTS" | translate }}
              </a>
              <a class="dropdown-item cursor-pointer" [routerLink]="'download-group-document'"
                 *ngIf="hasRole(ROLE_SUPERADMIN)">
                <i class="fa fa-download" aria-hidden="true"></i> {{ "NAV-BAR.DOWNLOAD-DOCUMENTS" | translate }}
              </a>
              <a class="dropdown-item cursor-pointer " [routerLink]="'parameter-board'"
                 *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER)"><i class="fa fa-table"
                                                                              aria-hidden="true"></i> {{ "NAV-BAR.PARAMETER-TABLE" | translate }}
              </a>
              <a class="dropdown-item cursor-pointer" [routerLink]="'ads'"
                 *ngIf="hasAuthority('own:view:ads:module')"><i class="fa fa-bell"
                                                                aria-hidden="true"></i> {{ "NAV-BAR.ADS" | translate }}
              </a>
              <a class="dropdown-item cursor-pointer" [routerLink]="'templates'"
                 *ngIf="hasAuthority('own:view:template:module')"><i class="fa fa-folder"
                                                                     aria-hidden="true"></i> {{ "NAV-BAR.TEMPLATE" | translate}}
              </a>
            </div>
          </a>
        </li>

        <li class="nav-item cursor-pointer"
            *ngIf="isAuthenticated && (hasAuthority('own:application:view:menu:documento') || hasRole(ROLE_SUPERADMIN))">
          <div class="nav-link" [routerLink]="'document'"><i
            class="far fa-copy"></i><span> {{ "NAV-BAR.DOCUMENT" | translate }}</span></div>
        </li>

        <li class="nav-item dropdown dmenu cursor-pointer"
            *ngIf="hasRole(ROLE_SUPERADMIN) || hasRole(ROLE_PARTNER) || hasRole(ROLE_ADMIN) || hasRole(ADMIN_IOFE)">
          <a class="nav-link " data-toggle="dropdown">
            <span><i class="fa fa-table"></i> {{ "NAV-BAR.REPORTS" | translate }}</span>
            <div class="dropdown-menu sm-menu">
              <a class="dropdown-item" [routerLink]="'service-report'"
                 *ngIf="true"><i class="fa fa-handshake"></i> {{ "NAV-BAR.SERVICES-REPORT" | translate }}</a>
<!--              <a class="dropdown-item" [routerLink]="'consolidated-iof-consumption-report'"
                 *ngIf="true"><i class="fas fa-wallet"></i> {{ "NAV-BAR.CONSOLIDATED-IOF" | translate }}</a>
              <a class="dropdown-item" [routerLink]="'report-storage'"
                 *ngIf="hasAuthority('own:view:report:storage:501')"><i class="fas fa-hdd"></i> Consolidado
                de almacenamiento</a>-->
            </div>
          </a>
        </li>

        <li class="nav-item cursor-pointer"
            *ngIf="isAuthenticated && hasAuthority('own:document:billing:10200')">
          <div class="nav-link" [routerLink]="'billing-services'"><i
            class="fas fa-file-invoice-dollar"></i><span> {{ "NAV-BAR.BILLING-SERVICES" | translate }}</span></div>
        </li>

        <li class="nav-item cursor-pointer" (click)="openRCDSignatureDownloadDialog()">
          <div class="nav-link">
                  <span>
                    <i class="fas fa-window-restore"></i>
                    {{ "NAV-BAR.SIGNATURE-COMPONENT-VERIFICATION" | translate }}
                  </span>
          </div>
        </li>
        <li class="nav-item cursor-pointer">
          <a class="nav-link active text-white font-weight-bold d-flex align-items-center" style="gap: 0.5rem;" target="_blank"
             href="https://iofesac.atlassian.net/wiki/spaces/DPA/overview">
            <i class="fa fa-cloud fa-lg color-golden"></i> <span>Documentación API REST</span>
          </a>
        </li>

        <li class="nav-item nav-link dropdown menu cursor-pointer mode-computer">
            <span class="" id="navbardrop22" data-toggle="dropdown">
              <i class="fa-globe fas color-golden"> </i> &nbsp;
              <i class="flag-icon {{getImageLang()}}"></i>
            </span>
          <div class="dropdown-menu dropdown-menu-right">
                      <span>
                      <button class="dropdown-item" (click)="changeSiteLanguage('en')"><span
                        class="flag-icon flag-icon-us"> </span>&nbsp;&nbsp;{{ "BUTTON.ENGLISH" | translate }}
                      </button>
                      <button class="dropdown-item" (click)="changeSiteLanguage('es')"><span
                        class="flag-icon flag-icon-pe"> </span>&nbsp;&nbsp;{{ "BUTTON.SPANISH" | translate }}
                      </button>
                      </span>
          </div>
        </li>
        <li class="nav-item dropdown cursor-pointer" *ngIf="isAuthenticated">
          <a data-toggle="dropdown" class="nav-item nav-link dropdown-toggle " aria-expanded="false">
            <i class="fa fa-user"></i> <b class="caret"> {{ "NAV-BAR.PROFILE" | translate }}
          </b></a>
          <div class="dropdown-menu transform-initial dropdown-menu-lg-start">
            <a class="dropdown-item dropdown-item1">
              <strong class="fc-green"> {{profile.personName}}</strong>
              <span class="sub-item">{{role}}</span>
            </a>
            <div class="divider dropdown-divider"></div>
            <a class="dropdown-item dropdown-item1">
              <strong>{{profile.enterpriseNameView}}</strong>
              <span class="sub-item" *ngIf="existJob">{{profile.jobDescription}}</span>
            </a>
            <div class="divider dropdown-divider"></div>
            <a class="dropdown-item cursor-pointer" [routerLink]="'profile'"
               *ngIf="!isInvitedAuthenticated">
              <i class="fa fa-cog"></i> {{ "NAV-BAR.CONFIGURATION" | translate }}</a>
            <div class="divider dropdown-divider"></div>
            <a class="dropdown-item cursor-pointer" [routerLink]="''" (click)="logout()">
              <i class="fas fa-sign-out-alt"></i> {{ "NAV-BAR.SIGN-OUT" | translate }}</a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</div>
<app-loading *ngIf="loading"></app-loading>
